import { template } from 'utils/helper';
import { getWindowOptions } from 'utils/hooks/storage/storageGets';
import { setWindowCommons, setWindowOptions } from 'utils/hooks/storage/storageSets';

export const url_commons = {
	web_static_data: 'commons/web-static-data/',
	notes: 'commons/notes/',
	note: template`commons/notes/${'slug'}/`,
	compliance_finteq_privacy_policy: 'commons/compliance/finteq-privacy-policy/'
};


const commons = service => ({
	getStaticData: async () => {
		const response = await service.get(url_commons.web_static_data);
		setWindowCommons(response.data);
		
		const options = getWindowOptions();
		const currencyPLN = response.data.currencies.find(currency => currency.code === 'PLN');
		const opt = { ...options, defaultCurrency: currencyPLN };
		setWindowOptions(opt);

		return response;
	},
	getNotes: ({ rowsPerPage, page }) => {
		const pagination = Object.assign({},
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);
		return service.get(url_commons.notes, {
			params: {
				...pagination
			}
		});
	},
	addNote: values => service.post(url_commons.notes, values),
	updateNote: values => service.put(url_commons.note({ slug: values.slug }), values),
	deleteNote: slug => service.delete(url_commons.note({ slug })),
	getPrivacyPolicy: ({ lang, ...params }) => service.get(url_commons.compliance_finteq_privacy_policy, {
		headers: {
			'Accept-Language': lang
		},
		params
	})
});

export default commons;
